import { IRbac } from '../../apis/__shared/rbac.interfaces';

export const mockRbac: IRbac = {
  dashboard: {
    finance: {
      read: true,
      write: true,
      delete: false,
    },
    people: {
      read: true,
      write: true,
      delete: false,
    },
    events: {
      read: true,
      write: true,
      delete: true,
    },
  },
  students: {
    studentList: {
      read: true,
      write: true,
      delete: true,
    },
    attendance: {
      read: true,
      write: true,
      delete: false,
    },
    fees: {
      read: true,
      write: true,
      delete: false,
    },
    events: {
      read: true,
      write: true,
      delete: true,
    },
    scores: {
      read: true,
      write: true,
      delete: false,
    },
    documents: {
      read: true,
      write: true,
      delete: true,
    },
  },
  staff: {
    staffList: {
      read: true,
      write: true,
      delete: true,
    },
    attendance: {
      read: true,
      write: true,
      delete: false,
    },
    payouts: {
      read: true,
      write: true,
      delete: false,
    },
    events: {
      read: true,
      write: true,
      delete: true,
    },
    documents: {
      read: true,
      write: true,
      delete: true,
    },
  },
  academics: {
    curriculum: {
      read: true,
      write: true,
      delete: true,
    },
    schedules: {
      read: true,
      write: true,
      delete: true,
    },
    lessonPlans: {
      read: true,
      write: true,
      delete: true,
    },
    materials: {
      read: true,
      write: true,
      delete: true,
    },
    assessments: {
      read: true,
      write: true,
      delete: true,
    },
    library: {
      read: true,
      write: true,
      delete: true,
    },
  },
  communications: {
    messaging: {
      read: true,
      write: true,
      delete: true,
    },
    announcements: {
      read: true,
      write: true,
      delete: true,
    },
    concerns: {
      read: true,
      write: true,
      delete: false,
    },
    events: {
      read: true,
      write: true,
      delete: true,
    },
    meetings: {
      read: true,
      write: true,
      delete: true,
    },
  },
  finance: {
    financeList: {
      read: true,
      write: true,
      delete: false,
    },
    scholarships: {
      read: true,
      write: true,
      delete: false,
    },
    financialReports: {
      read: true,
      write: true,
      delete: false,
    },
  },
  analytics: {
    performance: {
      read: true,
      write: false,
      delete: false,
    },
    customDashboards: {
      read: true,
      write: true,
      delete: true,
    },
  },
  administration: {
    transport: {
      read: true,
      write: true,
      delete: true,
    },
    inventory: {
      read: true,
      write: true,
      delete: true,
    },
    healthAndSafety: {
      read: true,
      write: true,
      delete: false,
    },
  },
  users: {
    parents: {
      read: true,
      write: true,
      delete: true,
    },
    visitors: {
      read: true,
      write: true,
      delete: true,
    },
    guests: {
      read: true,
      write: true,
      delete: true,
    },
  },
  settings: {
    userManagement: {
      read: true,
      write: true,
      delete: true,
    },
    complianceManagement: {
      read: true,
      write: true,
      delete: false,
    },
  },
  profile: {
    personalDetails: {
      read: true,
      write: true,
      delete: false,
    },
    documents: {
      read: true,
      write: true,
      delete: true,
    },
    calendar: {
      read: true,
      write: true,
      delete: true,
    },
    leaves: {
      read: true,
      write: true,
      delete: false,
    },
  },
  guardian: {
    dashboard: { read: true, write: false, delete: false },
    academicsSchedule: { read: true, write: false, delete: false },
    academicsCurriculum: { read: true, write: false, delete: false },
    academicsLessonPlans: { read: true, write: false, delete: false },
    academicsMaterials: { read: true, write: false, delete: false },
    academicsAssessments: { read: true, write: false, delete: false },
    academicsHomework: { read: true, write: false, delete: false },
    academicsAttendance: { read: true, write: false, delete: false },
    academicsLibrary: { read: true, write: false, delete: false },
    fees: { read: true, write: false, delete: false },
    transport: { read: true, write: false, delete: false },
    documents: { read: true, write: false, delete: false },
    eventsCommunication: { read: true, write: false, delete: false },
    concerns: { read: true, write: true, delete: false },
    profile: { read: true, write: true, delete: false },
    settings: { read: true, write: false, delete: false },
  },
};
